import { Component } from '@angular/core';
import { CmsLinkComponent, CmsService, isNotNullable } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, switchMap, combineLatest, distinctUntilChanged, map, filter } from 'rxjs';

@Component({
  selector: 'app-cms-custom-breadcrumb',
  templateUrl: './cms-custom-breadcrumb.component.html',
  styleUrl: './cms-custom-breadcrumb.component.scss',
  standalone: false,
})
export class CmsCustomBreadcrumbComponent {
  components$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap((data: { breadcrumbs: string }) =>
      combineLatest(
        (data?.breadcrumbs ?? '').split(' ').map(item =>
          this.cmsService.getComponentData<CmsLinkComponent>(item).pipe(
            distinctUntilChanged(),
            filter(item => isNotNullable(item)),
            map(item => this.normalizeCmsLinkToLabelAndLink(item)),
          ),
        ),
      ),
    ),
  );

  constructor(
    public componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
  ) {}

  normalizeCmsLinkToLabelAndLink(cmsLink: CmsLinkComponent): { label: string; link: string } {
    const label = cmsLink?.linkName || 'No link name';
    const link = cmsLink?.url || '#';
    return { label, link };
  }
}
